import {
    AnswerFormattingOptions,
    InteractionType,
    IQuestion,
    QuestionType,
    renderAnswer,
} from "@sp-crm/core";
import React, { ReactNode } from "react";
import { CommunityCardBasicsFragment } from "../../../../generated/graphql";
import { breakNewlines } from "util/text";
import { isUrl, sanitizeUri } from "util/uri";

type Answer = CommunityCardBasicsFragment["answers"][0];

export const blockLinkClasses =
    "block hover:underline text-brand-600 hover:text-brand-900";

interface RenderCommunityAnswerOptions {
    truncateLength?: number;
}

export const renderCommunityAnswerWithUrlSupport = (
    question: IQuestion,
    answer: Answer,
    formattingOptions: AnswerFormattingOptions,
    options?: RenderCommunityAnswerOptions,
): ReactNode => {
    const renderedValue = renderAnswer(question, answer, {}, formattingOptions);
    const isUrlField =
        question.questionType === QuestionType.text &&
        (question.interaction === InteractionType.url ||
            question.legacyCommunityInteraction === InteractionType.url);

    if (isUrlField && renderedValue && isUrl(renderedValue)) {
        const displayText = options?.truncateLength
            ? renderedValue.length > options.truncateLength
                ? renderedValue.substring(0, options.truncateLength) + "…"
                : renderedValue
            : renderedValue;

        return (
            <a
                className={blockLinkClasses}
                target="_blank"
                rel="noreferrer"
                href={sanitizeUri(renderedValue)}>
                {displayText}
            </a>
        );
    }

    return <>{breakNewlines(renderedValue)}</>;
};
